var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-profile-title"},[_vm._t("default"),(_vm.counter !== undefined)?_c('span',{staticClass:"counter"},[_vm._v(_vm._s(_vm.counter))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }